import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {trackEvent} from '../helpers/listeners/analytics';
import {filterUrl} from "../helpers/filters";
import {getVideoId} from "../helpers/video";
import InlineModalVideo from "./InlineModalVideo";
import {trackEventByUrl} from "../helpers/events";

interface Data {
    paragraphById: {
        fieldVarLinkTarget: string;
        fieldVarButtonStyle: string;
        fieldVarLink: Array<{
            title: string;
            url: Array<{
                routed: boolean;
                path: string;
            }>;
        }>;
    }
}

class CTAQuery extends Query<Data, {id: string}> {}

const GET_COMPONENT = gql`
query paragraphById($id: String!) {
  paragraphById:paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphObjectCta {
          fieldVarLink {
            title
            url {
              routed
              path
            }
          }
          fieldVarButtonStyle
          fieldVarLinkTarget
        }
      }
    }
  }
}
`;

const CTA = ({id, markComponentLoadedAs}) => (
    <CTAQuery asyncMode query={GET_COMPONENT} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error || !data.paragraphById) {
                markComponentLoadedAs(id, true);
                return <div>{error || null}</div>;
            }

            const field = data.paragraphById;

            const getClassName = (style) => {
                let setClassName = '';

                if ( style === 'text-cta' || style === 'text-cta--white' || style === 'text-cta-orange' || style === 'text-cta--red' ) {
                    setClassName = style;
                } else if (style) {
                    setClassName = `button button--${style}`;
                } else {
                    setClassName = 'button button--primary';
                }

                return setClassName;
            };

            if (!field.fieldVarLink.url || !field.fieldVarLink.url.path) {
                markComponentLoadedAs(id, true);
                return null;
            }

            const videoId = getVideoId(field.fieldVarLink.url.path);

            markComponentLoadedAs(id, true);

            if (videoId) {
                return (
                    <InlineModalVideo videoId={videoId}
                                      videoUrl={field.fieldVarLink.url.path}
                                      title={field.fieldVarLink.title}
                                      className={getClassName(field.fieldVarButtonStyle)}/>
                );
            }

            return (
                <a onClick={() => {
                    // Track Link click if non-modal Vimeo link
                    if (!videoId && filterUrl(field.fieldVarLink.url.path).includes('vimeo')) {
                        trackEvent('Video', 'Link Click', `${document.title.split('|')[0].trim()} - vimeo`);
                    }

                    trackEventByUrl(field.fieldVarLink.url.path, field.fieldVarLink.title);
                }} href={filterUrl(field.fieldVarLink.url.path)} className={getClassName(field.fieldVarButtonStyle)} target={field.fieldVarLinkTarget}>
                    {field.fieldVarLink.title}
                </a>
            );
        }}
    </CTAQuery>
);

CTA.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    handleLoadedComponents: PropTypes.func.isRequired
};

export default CTA;



// WEBPACK FOOTER //
// ./frontend/components/CTA.jsx